import { render, staticRenderFns } from "./inputBlocks.vue?vue&type=template&id=60192952"
import script from "./inputBlocks.vue?vue&type=script&lang=js"
export * from "./inputBlocks.vue?vue&type=script&lang=js"
import style0 from "./inputBlocks.vue?vue&type=style&index=0&id=60192952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports